<template>
  <div>
    <form
      ref="form"
      id="form_id"
      class="row g-3 needs-validation"
      novalidate
      @submit.prevent="check"
    >
      <div
        class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <div class="row">
          <div class="col-9">
            <h1 class="h2 text-muted">RATING ENGINE / ADD INSURER</h1>
          </div>

          <div class="col-3" style="text-align:right;">
            <button type="button" class="btn btn-danger" @click="discard">
              Discard
            </button>
            <div class="divider" />
            <button class="btn btn-primary" type="submit">
              Save
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        Error: {{ reason }}
      </div>
      <div class="col-md-7">
        <label for="fullname" class="form-label">Insurer Name</label>
        <input
          class="form-control"
          id="fullname"
          v-model="insurer_name"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Insurer Name is required!
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import config from "../../config";
// import $ from "jquery";
export default {
  data() {
    return {
      insurer_name: "",
      error: false,
      reason: "",
    };
  },
  methods: {
    async check() {
      // console.log($.trim($("#fullname").val()).length);
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_name: this.insurer_name,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_insurer",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/insurers");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
    discard() {
      this.$router.push("/insurers");
    },
  },
  mounted() {
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped>
.divider {
  width: 10px;
  height: auto;
  display: inline-block;
}
</style>
